__turbopack_context__.v({
  "product-list": "product-list-component-module-scss-module__zyTzAG__product-list",
  "product-list__facets-wrapper": "product-list-component-module-scss-module__zyTzAG__product-list__facets-wrapper",
  "product-list__selected-facets-wrapper": "product-list-component-module-scss-module__zyTzAG__product-list__selected-facets-wrapper",
  "product-list__teaser-container": "product-list-component-module-scss-module__zyTzAG__product-list__teaser-container",
  "product-list__tile": "product-list-component-module-scss-module__zyTzAG__product-list__tile",
  "product-list__tiles-wrapper": "product-list-component-module-scss-module__zyTzAG__product-list__tiles-wrapper",
});
